import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.109 10.396a1.135 1.135 0 0 0 0 1.605l2.981 2.982a1.135 1.135 0 0 0 1.605 0L11.677 12a1.135 1.135 0 1 0-1.606-1.605l-1.043 1.043V1.605a1.135 1.135 0 0 0-2.27 0v9.834l-1.044-1.043a1.135 1.135 0 0 0-1.605 0",
      "clip-rule": "evenodd",
      opacity: ".5"
    }, null, -1)
  ]))]))
}
export default { render: render }